module.exports = __webpack_public_path__ + "be7f5343ff8e4733176e603eea8ac62b.png";